import { isOfType, ProductType, PlannerProductComponent, getProductReferenceFor, ShoppingBagComponent, InteriorComponent, OuterMeasurementsComponent, AssemblyInstructionsComponent, HideInSeeThroughSystemComponent, DistanceMeasurementComponent } from '@inter-ikea-storageone/range';
import { Direction } from '@inter-ikea-storageone/range/src/core-api/components/DistanceMeasurementComponent';
export const brorComponentResolver = (_coreApi, _products, _unavailableProducts, _productsNotInMarket, _coreSpecificProducts) => {
    const isShoppingProduct = isOfType([
        ProductType.BROR_SECTION,
        ProductType.BROR_SHELF_METAL_BLACK,
        ProductType.BROR_SHELF_WALL_METAL_BLACK,
        ProductType.BROR_CABINET_FLOOR,
        ProductType.BROR_CABINET_BLACK,
        ProductType.BROR_CABINET_GREEN,
        ProductType.BROR_PEGBOARD_SET,
        ProductType.BROR_WALL_SECTION_UNIT,
        ProductType.BROR_WORK_BENCH,
        ProductType.BROR_TROLLEY,
        ProductType.BROR_DRAWER_METAL_BLACK,
        ProductType.BROR_SHELF_GREEN_PINE,
        ProductType.BROR_RAIL,
        ProductType.BROR_FOUR_PACK_SHELF,
        ProductType.BROR_SHELF_BLACK_PINE,
        ProductType.PEGBOARD,
        ProductType.SAMLA_ORGANIZER,
        ProductType.SOCKERBIT_ORGANIZER,
        ProductType.KUGGIS_ORGANIZER,
        ProductType.KNAGGLIG_ORGANIZER
    ]);
    //Should include all product types that should be displayed in the product sidebar
    const isPlannerProduct = isOfType([
        ProductType.BROR_SECTION,
        ProductType.BROR_SHELF_METAL_BLACK,
        ProductType.BROR_CABINET_BLACK,
        ProductType.BROR_CABINET_GREEN,
        ProductType.PEGBOARD,
        ProductType.BROR_PEGBOARD_SET,
        ProductType.BROR_WALL_SECTION_UNIT,
        ProductType.BROR_WORK_BENCH,
        ProductType.BROR_TROLLEY,
        ProductType.BROR_DRAWER_METAL_BLACK,
        ProductType.BROR_SHELF_GREEN_PINE,
        ProductType.BROR_RAIL,
        ProductType.BROR_SHELF_WALL_METAL_BLACK,
        ProductType.BROR_CABINET_FLOOR,
        ProductType.BROR_SHELF_BLACK_PINE,
        ProductType.BROR_FOUR_PACK_SHELF,
        ProductType.SAMLA_ORGANIZER,
        ProductType.SOCKERBIT_ORGANIZER,
        ProductType.KUGGIS_ORGANIZER,
        ProductType.KNAGGLIG_ORGANIZER
    ]);
    const shouldBeIncludedInOuterMeasurement = isOfType([
        ProductType.BROR_SECTION,
        ProductType.BROR_CABINET_BLACK,
        ProductType.BROR_CABINET_GREEN,
        ProductType.PEGBOARD,
        ProductType.BROR_PEGBOARD_SET,
        ProductType.BROR_WALL_SECTION_UNIT,
        ProductType.BROR_CABINET_FLOOR,
        ProductType.BROR_SHELF_WALL_METAL_BLACK,
        ProductType.BROR_RAIL
    ]);
    const shouldHaveAssemblyInstructions = isOfType([ProductType.BROR_SECTION]);
    const isInterior = isOfType([ProductType.BROR_SHELF_METAL_BLACK, ProductType.BROR_PEGBOARD_SET]);
    const hideInSeeThroughEntitySystem = isOfType([
        ProductType.BROR_SECTION,
        ProductType.BROR_CABINET_BLACK,
        ProductType.BROR_CABINET_GREEN,
        ProductType.PEGBOARD,
        ProductType.BROR_WORK_BENCH,
        ProductType.BROR_PEGBOARD_SET,
        ProductType.BROR_CABINET_FLOOR,
        ProductType.BROR_WALL_SECTION_UNIT
    ]);
    const shouldHaveDistanceUpDown = isOfType([
        ProductType.BROR_SHELF_METAL_BLACK,
        ProductType.BROR_CABINET_BLACK,
        ProductType.BROR_CABINET_GREEN,
        ProductType.BROR_DRAWER_METAL_BLACK,
        ProductType.BROR_SHELF_GREEN_PINE,
        ProductType.BROR_FOUR_PACK_SHELF,
        ProductType.BROR_SHELF_BLACK_PINE,
        ProductType.BROR_SHELF_WALL_METAL_BLACK,
        ProductType.BROR_PEGBOARD_SET,
        ProductType.BROR_RAIL
    ]);
    const shouldHaveDistanceLeftRight = isOfType([
        ProductType.BROR_SECTION,
        ProductType.BROR_WALL_SECTION_UNIT,
        ProductType.BROR_TROLLEY,
        ProductType.BROR_WORK_BENCH
    ]);
    const shouldHaveDistanceAllDirections = isOfType([
        ProductType.BROR_CABINET_BLACK,
        ProductType.BROR_CABINET_GREEN,
        ProductType.BROR_CABINET_FLOOR,
        ProductType.PEGBOARD,
        ProductType.BROR_PEGBOARD_SET
    ]);
    const componentBuilder = {
        build: (entity) => {
            if (shouldBeIncludedInOuterMeasurement(entity)) {
                entity.addComponent(new OuterMeasurementsComponent());
            }
            if (shouldHaveDistanceLeftRight(entity)) {
                entity.addComponent(new DistanceMeasurementComponent([Direction.LEFT, Direction.RIGHT], [], true));
            }
            if (shouldHaveDistanceUpDown(entity)) {
                entity.addComponent(new DistanceMeasurementComponent([Direction.UP, Direction.DOWN], [Direction.UP]));
            }
            if (shouldHaveDistanceAllDirections(entity)) {
                entity.addComponent(new DistanceMeasurementComponent([Direction.UP, Direction.DOWN, Direction.LEFT, Direction.RIGHT], [], true));
            }
            if (isPlannerProduct(entity)) {
                entity.addComponent(new PlannerProductComponent(getProductReferenceFor(entity)));
            }
            if (isShoppingProduct(entity)) {
                entity.addComponent(new ShoppingBagComponent(getProductReferenceFor(entity)));
            }
            if (isInterior(entity)) {
                entity.addComponent(new InteriorComponent());
            }
            if (shouldHaveAssemblyInstructions(entity)) {
                entity.addComponent(new AssemblyInstructionsComponent());
            }
            if (hideInSeeThroughEntitySystem(entity)) {
                entity.addComponent(new HideInSeeThroughSystemComponent());
            }
        }
    };
    return {
        resolveComponentBuilder: () => componentBuilder
    };
};
//# sourceMappingURL=brorComponentResolver.js.map